import React from 'react';

const Header = () => {
  return (
    <header className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <div className="text-2xl font-bold text-shinsegae-navy">
              신세계 그룹
            </div>
            <div className="ml-4 text-lg text-gray-600">
              WARP VPN 설치 안내
            </div>
          </div>
          <nav className="hidden md:flex space-x-8">
            <a href="#guide" className="text-gray-700 hover:text-shinsegae-blue">
              설치 가이드
            </a>
            <a href="#download" className="text-gray-700 hover:text-shinsegae-blue">
              앱 다운로드
            </a>
            <a href="#faq" className="text-gray-700 hover:text-shinsegae-blue">
              FAQ
            </a>
            <a href="#contact" className="text-gray-700 hover:text-shinsegae-blue">
              문의
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
